import { Dictionary } from '@common/types';

export const BASE_URL = 'NewTms';

export const DICTIONARIES_WITH_PROJECT_PARAMETER = [Dictionary.Vehicle];
export const DICTIONARIES_WITH_DATA_PROJECT_PARAMETER = [Dictionary.Order, Dictionary.Vehicle, Dictionary.Depot, Dictionary.Driver];
